// 封装一个 axios 文件
import axios from "axios";
import store from "@/store";
import vm from '@/main'
import {
    Message
} from 'element-ui'

const showMessage = Symbol('showMessage');

// 重写
class DonMessage {
    success(options, single = true) {
        this[showMessage]('success', options, single)
    }

    warning(options, single = true) {
        this[showMessage]('warning', options, single)
    }

    info(options, single = true) {
        this[showMessage]('info', options, single)
    }

    error(options, single = true) {
        this[showMessage]('error', options, single)
    }

    [showMessage](type, options, single) {
        if (single) {
            // 判断是否已存在Message
            if (document.getElementsByClassName('el-message').length === 0) {
                Message[type](options)
            }
        } else {
            Message[type](options)
        }
    }
}

// 使用这个
var MessageOnce = new DonMessage();

axios.defaults.baseURL = '';

// 创建
const request = axios.create();

// 设置请求拦截器
request.interceptors.request.use(
    function (config) {

        // 验证token
        const token = localStorage.token;
        if (token) {
            config.headers['Content-Type'] = 'application/json; charset=UTF-8';
            config.headers['token'] = token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 设置响应拦截器
request.interceptors.response.use(
    function (response) { 

      if (response.data.code == '100041' || response.data.code == '10004') {
            // vm.$message.error("登录凭证已过期，请重新登录");
            vm.$router.push('/login');
            MessageOnce.error({
                message: "登录信息已失效，请重新登录"
            });
            localStorage.removeItem('token');
        }
        return response.data.data || response.data;
    },
    function (error) {
        switch (error.response.status) {
            case 500:
                Message.error('系统异常');
                break;
            case 400:
                Message.error('参数错误');
                break;
            case 405:
                vm.$router.push('/login');
                Message.error("登录信息已失效，请重新登录");
                localStorage.removeItem('token');
            break;
            case 700:
              vm.$router.push('/login');
              Message.error("当前账号无权限登录");
              localStorage.removeItem('token');
          break;
            case 10004:
              vm.$router.push('/login');
              Message.error("token无效或者过期!");
              localStorage.removeItem('token');
              break;

            default:
                break;
        }
        return '系统错误'
    }
);

// 暴露对象
export default request;
